module.exports = __webpack_public_path__ + "img/26.79c4f6ee.jpg";